var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.277,
    height: 16.042,
    viewBox: "0 0 19.277 16.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7052",
    "data-name": "Group 7052",
    transform: "translate(-389.553 -513.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-show-1087646",
    transform: "translate(389.553 513.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M166.269,122.6l-.173-.319a11.313,11.313,0,0,0-2.693-3.219l2.05-1.287a.433.433,0,0,0-.457-.735l-2.321,1.457c-.108-.078-.218-.153-.328-.226a11.155,11.155,0,0,0-2.958-1.422l1.009-3.12a.432.432,0,1,0-.821-.269l-1.026,3.174a8.9,8.9,0,0,0-3.727,0l-1.026-3.173a.432.432,0,1,0-.821.268l1.009,3.12a11.153,11.153,0,0,0-2.957,1.422c-.111.074-.221.15-.328.227l-2.322-1.458a.429.429,0,0,0-.594.138.435.435,0,0,0,.137.6l2.05,1.287a11.575,11.575,0,0,0-2.37,2.679q-.173.274-.324.55l-.061.112-.107.189a.462.462,0,0,0,0,.456l.18.314a11.678,11.678,0,0,0,3.74,4,9.635,9.635,0,0,0,11.318,0,11.752,11.752,0,0,0,3.751-4.008l.173-.318a.46.46,0,0,0,0-.439Zm-.974.317a9.579,9.579,0,0,1-17.207,0l0-.008-.052-.091.052-.092,0-.008c.086-.159.178-.315.276-.472a9.554,9.554,0,0,1,16.922.483l.005.008.039.07h.012l.007.013Zm-8.608-3.576a3.479,3.479,0,1,0,3.462,3.479A3.471,3.471,0,0,0,156.687,119.34Zm0,6.04a2.562,2.562,0,1,1,2.549-2.562A2.559,2.559,0,0,1,156.687,125.38Z",
    transform: "translate(-147.048 -113.16)",
    fill: "#f37320"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.451760b072f10f76757e61689559e25a.svg";
export { ForwardRef as ReactComponent };